<mat-toolbar class="ntk-header">
  <span class="display__xs fw__500 caption">Brand Builder Research</span>
  <span class="ntk-header__spacer"></span>
  <img class="ntk-header__logo" [ngSrc]="'assets/logos/by-empathyIQ.svg'" alt="Powered by EmpathyIQ" width="180" height="34" />
</mat-toolbar>
